import AWSAppSyncClient, {
    createAppSyncLink
} from "aws-appsync";
import {
    AmplifyEventBus
} from 'aws-amplify-vue';
import * as localForage from "localforage";
import Vue from "vue";
import {
    Auth
} from 'aws-amplify';
import VueApollo from "vue-apollo";
import {
    WebSocketLink
} from 'apollo-link-ws'
import ApolloLinkTimeout from 'apollo-link-timeout';
import {
    ApolloLink
} from 'apollo-link';
import {
    createHttpLink
} from 'apollo-link-http';
import {
    onError
} from 'apollo-link-error';
const AUTH_TYPE = require('aws-appsync/lib/link/auth-link').AUTH_TYPE;
const type = AUTH_TYPE.AWS_IAM;
const aws_exports = require('./exports').default;
const onErrorLink = onError(({
    graphQLErrors,
    networkError
}) => {
    if (graphQLErrors) {
        graphQLErrors.map(({
            message,
            locations,
            path
        }) => {
            console.log(
                ` [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
        });
    }
    if (networkError) {
        console.log(` [Network error]: ${networkError}`);
    }
});
const timeoutLink = new ApolloLinkTimeout(30000)
const httpLink = createHttpLink({
    uri: aws_exports.ENDPOINT
});
const appSyncLink = createAppSyncLink({
    url: aws_exports.ENDPOINT,
    region: aws_exports.REGION,
    path: aws_exports.PATH,
    resultsFetcherLink: httpLink,
    auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(),
    },
    complexObjectsCredentials: () => Auth.currentCredentials(),
    fetchPolicy: 'network-only'
});
const link = ApolloLink.from([
    onErrorLink,
    timeoutLink,
    //httpLink
    appSyncLink
])
const defaultClient = new AWSAppSyncClient({
    fetchPolicy: 'network-only',
    offlineConfig: {
        storage: localForage
    }
}, {
    link
});

const apolloProvider = new VueApollo({
    defaultClient
});

Vue.use(VueApollo);

export default apolloProvider;